import {ArrowRight} from "lucide-react";

type ModalCardContentProps = {
  card: {
    title: string;
    description: string;
    image: string | null;
  };
  index: number;
  onClick: (index: number) => void;
};

const ModalCardContent = ({card, index, onClick}: ModalCardContentProps) => {
  return (
    <div className="card-item" onClick={() => onClick(index)}>
      {card.image && <img src={card.image} alt="" className="card-image" />}

      <div className="card-content">
        <h3>{card.title}</h3>
        <p>{card.description}</p>
        <button>
          Learn More <ArrowRight className="arrow" />
        </button>
      </div>
    </div>
  );
};

export default ModalCardContent;
